import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AppService } from '../services/app.service';
import { ActivatedRoute } from '@angular/router';
import { AuthCodeFormComponentUser } from '../utils/auth-code-form-user/auth-code-form-user.component';
import { ButtonModule } from 'primeng/button';
import { ContactInfo, ContactInfoService } from '../services/contact-info.service';

@Component({
    selector: 'app-block-request',
    imports: [AuthCodeFormComponentUser, ButtonModule],
    templateUrl: './block-request.component.html',
    styleUrl: './block-request.component.scss'
})
export class BlockRequestComponent implements AfterViewInit {

  token: string = '';
  client!: number;
  enProceso = false;
  showSuccess = false;
  showResponse=false;
  showOtp=false;
  contact!: ContactInfo;
  
  constructor(private services: AppService, private route: ActivatedRoute, private contactSvc: ContactInfoService) {
    this.contactSvc.get().subscribe(c => this.contact = c);
    this.route.queryParamMap.subscribe((params) => {
      this.token = params.get('token') || '';
      this.client = parseInt(params.get('client')!.toString()) || 0;
    });
  }
  
  ngAfterViewInit(): void {
    

  }

  sendRequestBlock(){
    this.enProceso = true
    this.services.blockAccount(this.client, this.token,false,"").subscribe({
      next: (data: any) => {
        
        this.enProceso = false;
        if (data.isSuccess) {
          
          if(data.message.includes('Mensaje enviado')){
            this.showOtp=true;
          }else{
            this.showSuccess=true;
            this.showResponse=true;
            this.showOtp=false;
          }
         
   
        }
      },
      error: (error: any) => {
        this.showResponse=true;
        this.enProceso = false;
        this.showSuccess = false;
       
      }
    })
  }

  closeForm(resp:any){
    this.showOtp=false;
    this.showResponse=true;
    this.showSuccess=true;
    
   
   }


}


